import axios from "axios";
import { baseURL } from "./common.js";

// axios 인스턴스 생성
const api = axios.create({
    baseURL: baseURL,
  });

  export default {
    methods: {
        search01(level, successCallback, errorCallback) {
            api.post('/api/dailyword/search01', {level})
          .then(successCallback)
          .catch(errorCallback);
        },
        updateWord01(successCallback, errorCallback) {
          api.post('/api/dailyword/updateWord01')
        .then(successCallback)
        .catch(errorCallback);
      },
    },

  };